import { useState, createContext, useContext } from "react";
import { useRoute } from "@/lib/hooks";
import { Header } from "@/components/Header";
import { BrowsePage } from "@/pages/BrowsePage";
import { ItemDetailPage } from "@/pages/ItemDetailPage";
import { SwapsPage } from "@/pages/SwapsPage";
import { TradeBuilderPage } from "@/pages/TradeBuilderPage";
import { ProfilePage } from "@/pages/ProfilePage";
import { ListItemPage } from "@/pages/ListItemPage";
import { TooltipProvider } from "@/components/ui/tooltip";
import "./index.css";

interface AppContextType {
	currentUserId: string;
	setCurrentUserId: (id: string) => void;
	navigate: (to: string) => void;
}

export const AppContext = createContext<AppContextType>({
	currentUserId: "user-1",
	setCurrentUserId: () => {},
	navigate: () => {},
});

export function useApp() {
	return useContext(AppContext);
}

export function App() {
	const { path, navigate } = useRoute();
	const [currentUserId, setCurrentUserId] = useState("user-1");

	const renderPage = () => {
		if (path === "/" || path === "/browse") return <BrowsePage />;
		if (path.startsWith("/item/")) return <ItemDetailPage itemId={path.split("/item/")[1]} />;
		if (path === "/swaps") return <SwapsPage />;
		if (path.startsWith("/trade/")) return <TradeBuilderPage targetUserId={path.split("/trade/")[1]} />;
		if (path.startsWith("/profile/")) return <ProfilePage userId={path.split("/profile/")[1]} />;
		if (path === "/profile") return <ProfilePage userId={currentUserId} />;
		if (path === "/list") return <ListItemPage />;
		return <BrowsePage />;
	};

	return (
		<AppContext.Provider value={{ currentUserId, setCurrentUserId, navigate }}>
			<TooltipProvider>
				<div className="min-h-screen bg-background">
					<Header />
					<main className="container mx-auto px-4 py-6 max-w-7xl">
						{renderPage()}
					</main>
				</div>
			</TooltipProvider>
		</AppContext.Provider>
	);
}

export default App;
